import GaugeWithNeedle from '../../../../../../../components/Charts/GaugeNeedle/GaugeWithNeedle'



export default function GetLiverGauge() {

  return (

      <GaugeWithNeedle realAge={55} chronologicalAge={62} />
    
  );
};




